import { Component, OnDestroy, OnInit } from '@angular/core';
import { ColumnDef } from '../../shared/data-table/data-table.model';
import { StudentService } from '../../_services/student/student.service';
import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';
import { Router } from '@angular/router';
import { StudentOnlineSession } from '../../_models/student-online-sessions/student-online-session.model';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';
import { StudentVoiceHelperService } from '../../_helpers/student-voice-helper/student-voice-helper.service';
import { StudentFeedbackService } from '../../_services/student-feedback/student-feedback.service';
import { FeedbackSurvey } from '../../_models/student-feedback/feedback-survey.model';
import { FeedbackModalComponent } from '../../student-voice/feedback-modal/feedback-modal.component';
import { AuthenticationService, PlacementService } from '../../_services';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { MatDialog } from '@angular/material/dialog';
import { Guid } from 'guid-typescript';
import { DigitalClassroomAccess } from '../../_models/digital-classroom/digital-classroom-access.model';
import { LaunchVideoLibrary } from '../../_models/digital-classroom/digital-classroom-launch-library.model';
import { PlacementInformation } from '../../_models/maintenance/placement-maintenance.model';

@Component({
    selector: 'student-home',
    templateUrl: './student-home.component.html',
    styleUrls: ['./student-home.component.css'],
    standalone: false
})
export class StudentHomeComponent implements OnInit, OnDestroy {

  public columns: ColumnDef<StudentOnlineSession>[] = [
    { field: 'startDate', header: 'Date', type: 'date', dateFormat: 'EE dd MMM yyyy' },
    { field: 'sessionTime', header: 'Time', type: 'template', templateName: 'sessionTime' },
    { field: 'subject', header: 'Subject' },
    { field: 'sessionDelivery', header: 'Session Delivery' },
    { field: 'actions', header: 'Actions', type: 'template', templateName: 'actions' }
  ];

  public upcomingSessions: Array<StudentOnlineSession> = new Array<StudentOnlineSession>();
  private studentId: number;
  public availableSessionLink: string;
  public brambleEnabled: boolean = false;
  private subscription: Subscription;
  public launchSessionClicked: boolean = false;
  public sessionUrl: string;
  public placement: PlacementInformation = new PlacementInformation;
  public showDigitalClassroomButtons: boolean = false;

  private companyUrl: string = "";

  constructor(
    private studentService: StudentService,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private errorModalHelper: ErrorModalHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService,
    public dialog: MatDialog,
    private authService: AuthenticationService,
    private themeService: ThemeService,
    private readonly placementService: PlacementService,

  ) { }

  ngOnInit() {

    let featureList = new Array<string>();
    featureList.push("Student");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "Student")[0].enabled) {
      console.error("User does not have the required permissions to view the student landing screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname } });
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    this.studentId = this.authService.userSessionData.currentUser.id;

    this.getPlacementInformation();
    this.populateFutureSessions();
  }

  

  ngOnDestroy(): void {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
  }

  public launchSession(item: StudentOnlineSession): void {
    // this.router.navigate(["/student-online-lessons"]);
    if (item.digitalClassroomId != null && item.digitalClassroomEnabled) {
      this.launchDigitalClassroom(item);
    }
    else {
      window.open(item.onlineRoomAccessUrl, '_blank');
      this.launchSessionClicked = true;
      this.sessionUrl = item.onlineRoomAccessUrl;
    }
  }

  // private checkPendingFeedback(): void {
  //   this.loading = true;
  //   this.feedbackService.checkUserFeedbackSurveyOnLogin(this.studentId).subscribe((result: FeedbackSurvey) => {
  //     if (result) {
  //       const dialogRef = this.dialog.open(FeedbackModalComponent, {
  //         data: { feedbackSurvey: result },
  //         panelClass: 'my-dialog',
  //         disableClose: true
  //       });
  //     }
  //     this.loading = false;
  //   },
  //   error => {
  //     this.loading = false;
  //     if (error.status === 401) {
  //       this.router.navigate(['/login']);
  //     }
  //     else {
  //       this.errorModalHelper.show(error.message, error);
  //     }
  //   });
  // }

  private populateFutureSessions(): void {

    this.studentService.readUpcomingSessions(this.studentId).subscribe((sessions: StudentOnlineSession[]) => {
      this.upcomingSessions = sessions;
      this.setRefreshTimer();
    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });
  }

  private launchDigitalClassroom(session: StudentOnlineSession): void {
    session.studentId = this.studentId;
    this.studentService.launchDigitalClassroom(session).subscribe((access: DigitalClassroomAccess) => {
      setTimeout(() => {

        window.open(access.accessToken, '_blank');
        this.launchSessionClicked = true;
        this.sessionUrl = access.accessToken;

      }, 0);
    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });
  }

  public launchVideoLibrary() {

    const request: LaunchVideoLibrary =
    {
      digitalClassroomId: this.placement.digitalClassroomId,
      isSuperUser: false,
      clientId: 0,
      tutorId: 0,
      isStudent: true
    };

    this.placementService.launchVideoLibrary(request).subscribe((access: DigitalClassroomAccess) => {
      setTimeout(() => {
        window.open(`${access.accessToken}&userref=${this.studentId}STU`, '_blank');
      }, 0);

    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);

    });

  }

  public launchBrowerTest() {
    this.getCompanyUrl();
    window.open(`https://digitalclassroom.${this.companyUrl}.com/help/browser-test`, '_blank');
  }

  public launchNetworkTest() {
    this.getCompanyUrl();
    window.open(`https://digitalclassroom.${this.companyUrl}.com/help/network-requirements`, '_blank');
  }

  private getPlacementInformation() {
    try {
      this.studentService.readPlacementInformation(this.studentId).subscribe((data: Array<PlacementInformation>) => {
        this.placement = data.find(x => x.digitalClassroomEnabled);
        if (this.placement) {
          this.showDigitalClassroomButtons = this.placement.digitalClassroomEnabled;
        }
        else {
          this.showDigitalClassroomButtons = false;
        }
      })

    } catch (error) {

      let errorMessage = error.status === 401 ? "Unauthorized" : error.message;

      if (errorMessage == "Object reference not set to an instance of an object.") {
        errorMessage = "Client not found. Try another."
      }

      this.errorModalHelper.show(errorMessage, error);
    }
  }

  private setRefreshTimer(): void {
    this.subscription = timer(0, 30000).pipe(
      map(() => this.checkButtonDisableState())
    ).subscribe();
  }

  private checkButtonDisableState(): void {
    //TODO go to api for time
    this.placementService.getDateTimeNow().subscribe({
      next: (response: Date) => {
        this.upcomingSessions.forEach(session => {
          let disableButton = true;
          let brambleEnabled = false;
    
          let currentDateTime = new Date(response);
          const sessionDate = new Date(session.startDate);
    
          if (sessionDate.toDateString() == currentDateTime.toDateString()) {
    
            const startTime = new Date();
            const endTime = new Date();
    
            // Set the time values
            startTime.setHours(parseInt(session.startTime.split(":")[0], 10), parseInt(session.startTime.split(":")[1], 10), 0);
            endTime.setHours(parseInt(session.endTime.split(":")[0], 10), parseInt(session.endTime.split(":")[1], 10), 0);
    
            startTime.setMinutes(startTime.getMinutes() - 90);
            endTime.setMinutes(endTime.getMinutes() + 90);
    
            if (session.onlineRoomAccessUrl != null) {
              if (session.sessionDelivery.toLowerCase() === 'online' ||
                session.sessionDelivery.toLowerCase() === 'hybrid') {
                brambleEnabled = true;
              }
            }
    
            if (session.digitalClassroomEnabled || brambleEnabled) {
              disableButton = !this.isCurrentTimeBetween(startTime, endTime, currentDateTime)
            }
            else {
              disableButton = true;
            }
          }
    
          session.disableLaunchButton = disableButton;
          if (!disableButton) {
            this.availableSessionLink = session.onlineRoomAccessUrl;
          }
        });
      }, 
      error: (error: any) => {
        

      let errorMessage = error.status === 401 ? "Unauthorized" : error.message;

      if (errorMessage == "Object reference not set to an instance of an object.") {
        errorMessage = "Client not found. Try another."
      }

      this.errorModalHelper.show(errorMessage, error);
    },

    complete() {},
      
    });
  }

  private isCurrentTimeBetween(start: Date, end: Date, current: Date): boolean {
    return current >= start && current <= end;
  }

  private getCompanyUrl(){
    this.companyUrl = "teachingpersonnel"; // unified brand
  }

}
